/* global URLSearchParams */
export default param => {
  if (typeof URLSearchParams !== 'undefined') {
    const searchParams = new URLSearchParams(window.location.search)
    return searchParams.get(param)
  }
}
